export const PIPELINE_TOOL_OUTCOMES = ["succeeded", "house_miss", "failed", "invalid"] as const;
export type PipelineToolOutcome = (typeof PIPELINE_TOOL_OUTCOMES)[number];
